export const modularLibraryScreenCopy = {
  en: {
    readingUnavailable: 'Reading progress unavailable',
    readingLoading: 'Loading your current read…',
    readingDeskPlacement: 'On your reading desk. This shelf position is kept for later.',
    done: 'Done',
    left: 'Left',
    right: 'Right',
    center: 'Reading desk',
    extend: 'Add side shelves',
    reset: 'Reset',
    editHint: 'Tap a divider or lamp to select it.',
    browseHint: 'Swipe between the desk and side shelves.',
    divider: 'Divider · row {{row}}',
    remove: 'Merge shelves',
    restore: 'Restore divider',
    lamp: 'Lamp {{number}}',
    lightsOn: 'Light on',
    lightsOff: 'Light off',
    moveLeft: 'Move lamp left',
    moveRight: 'Move lamp right',
    previousDivider: 'Previous divider',
    nextDivider: 'Next divider',
    blocked: 'Move the object away from the divider first.',
    coverExclusive: 'Each cover needs its own space. Move any overlapping items before merging.',
    moveBlocked: 'The lamp needs a little more space here.',
    merged: 'Shelves merged. Light can pass through the opening.',
    restored: 'Divider restored.',
    extended: 'Added a shelf column to each side.',
    resetDone: 'Prototype reset.',
    local: 'Local prototype · changes last until you leave',
    overview: 'Zoom out',
    zoomIn: 'Zoom in',
    worldStatus: '{{count}} shelf columns · {{visible}} compartments rendered',
    bookSelected: '{{title}} · display book',
    canvas: 'Library shelves. Swipe left or right to explore.',
  },
  sk: {
    readingUnavailable: 'Pokrok v čítaní je nedostupný',
    readingLoading: 'Načítava sa rozčítaná kniha…',
    readingDeskPlacement:
      'Na čitateľskom stolíku. Toto miesto na polici zostáva odložené na neskôr.',
    done: 'Hotovo',
    left: 'Doľava',
    right: 'Doprava',
    center: 'Čitateľský stolík',
    extend: 'Pridať bočné police',
    reset: 'Obnoviť',
    editHint: 'Ťuknutím vyberte priečku alebo lampu.',
    browseHint: 'Potiahnutím prejdite od stolíka k policiam.',
    divider: 'Priečka · rad {{row}}',
    remove: 'Spojiť police',
    restore: 'Vrátiť priečku',
    lamp: 'Lampa {{number}}',
    lightsOn: 'Svetlo zapnuté',
    lightsOff: 'Svetlo vypnuté',
    moveLeft: 'Posunúť lampu doľava',
    moveRight: 'Posunúť lampu doprava',
    previousDivider: 'Predošlá priečka',
    nextDivider: 'Ďalšia priečka',
    blocked: 'Najprv odsuňte predmet od priečky.',
    coverExclusive:
      'Každá obálka potrebuje vlastný priestor. Pred spojením odsuňte prekrývajúce sa predmety.',
    moveBlocked: 'Lampa tu potrebuje viac miesta.',
    merged: 'Police sú spojené. Svetlo preniká cez otvor.',
    restored: 'Priečka je späť.',
    extended: 'Na každej strane pribudol stĺpec políc.',
    resetDone: 'Prototyp bol obnovený.',
    local: 'Lokálny prototyp · zmeny platia do odchodu',
    overview: 'Oddialiť',
    zoomIn: 'Priblížiť',
    worldStatus: '{{count}} stĺpcov · {{visible}} vykreslených priehradiek',
    bookSelected: '{{title}} · vystavená kniha',
    canvas: 'Police knižnice. Potiahnutím doľava alebo doprava ich preskúmate.',
  },
  cs: {
    readingUnavailable: 'Pokrok ve čtení je nedostupný',
    readingLoading: 'Načítá se rozečtená kniha…',
    readingDeskPlacement: 'Na čtenářském stolku. Toto místo na polici zůstává uložené na později.',
    done: 'Hotovo',
    left: 'Doleva',
    right: 'Doprava',
    center: 'Čtenářský stolek',
    extend: 'Přidat boční police',
    reset: 'Obnovit',
    editHint: 'Klepnutím vyberte příčku nebo lampu.',
    browseHint: 'Tažením přejděte od stolku k policím.',
    divider: 'Příčka · řada {{row}}',
    remove: 'Spojit police',
    restore: 'Vrátit příčku',
    lamp: 'Lampa {{number}}',
    lightsOn: 'Světlo zapnuté',
    lightsOff: 'Světlo vypnuté',
    moveLeft: 'Posunout lampu doleva',
    moveRight: 'Posunout lampu doprava',
    previousDivider: 'Předchozí příčka',
    nextDivider: 'Další příčka',
    blocked: 'Nejprve odsuňte předmět od příčky.',
    coverExclusive:
      'Každá obálka potřebuje vlastní prostor. Před spojením odsuňte překrývající se předměty.',
    moveBlocked: 'Lampa zde potřebuje více místa.',
    merged: 'Police jsou spojené. Světlo proniká otvorem.',
    restored: 'Příčka je zpět.',
    extended: 'Na každé straně přibyl sloupec polic.',
    resetDone: 'Prototyp byl obnoven.',
    local: 'Lokální prototyp · změny platí do odchodu',
    overview: 'Oddálit',
    zoomIn: 'Přiblížit',
    worldStatus: '{{count}} sloupců · {{visible}} vykreslených přihrádek',
    bookSelected: '{{title}} · vystavená kniha',
    canvas: 'Police knihovny. Tažením doleva nebo doprava je prozkoumáte.',
  },
} as const;
